// Warehouses Management Permissions
// Menu item: ادارة مستودعات المنتجات / View Warehouses (menu_item_id: 33)
// Warehouses spread across multiple sections, so we need to use the following permissions:
// Warehouse assets
export const WAREHOUSES_ASSETS_INDEX = 296;
export const WAREHOUSES_ASSETS_CREATE = 1182;
export const WAREHOUSES_ASSETS_UPDATE = 1183;
export const WAREHOUSES_ASSETS_DELETE = 1184;
export const WAREHOUSES_ASSETS_RESTORE = 1389;

// Warehouse equipments
export const WAREHOUSES_EQUIPMENTS_INDEX = 297;
export const WAREHOUSES_EQUIPMENTS_CREATE = 298;
export const WAREHOUSES_EQUIPMENTS_UPDATE = 299;
export const WAREHOUSES_EQUIPMENTS_DELETE = 300;
export const WAREHOUSES_EQUIPMENTS_RESTORE = 1391;

// Spare parts (spare-parts.store / show / update / destroy)
export const WAREHOUSES_SPAREPARTS_INDEX = 1326;
export const WAREHOUSES_SPAREPARTS_CREATE = 1327;
export const WAREHOUSES_SPAREPARTS_UPDATE = 1328;
export const WAREHOUSES_SPAREPARTS_DELETE = 1329;
export const WAREHOUSES_SPAREPARTS_RESTORE = 1392;

// POS (not in current menu permissions; kept for backward compatibility)
export const WAREHOUSES_POS_INDEX = 1193;
export const WAREHOUSES_POS_CREATE = 1194;
export const WAREHOUSES_POS_UPDATE = 1196;
export const WAREHOUSES_POS_DELETE = 1195;
export const WAREHOUSES_POS_RESTORE = 1390;

// Withdraw requests. 322 is withdraw-requests.index; this constant used to hold 1330, which is
// wallet.show — an unrelated permission, so the list was gated on whether the user could open the
// wallet. The WAREHOUSES_EXCHANGE_PERMISSION_* pair that sat here was mismapped the same way
// (185/186 are preset-reads.show and preset-reads.update), was referenced by nothing, and 185 no
// longer exists now that show follows index.
export const WAREHOUSES_WITHDRAW_REQUESTS_INDEX = 322;
